module.exports = __webpack_public_path__ + "img/business6E.66c2f4d5.png";